import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import EventState from './EventState';
import Utils from './Utils';
import DetailTable from './DetailTable';
import DetailTableDelete from './DetailTableDelete';

export default class EventAdmin extends Component {

    constructor(props) {
        super(props);

        this.state = {         
            myStateData:[],    // Data pro DialogDetail  
            myStateInvalidData:[],    // Data pro DialogDetail  
        }        
    }

// Iniciální načtení dat
    componentDidMount() {
      this.getReservations();
      //Poprvé hned aby se nečekalo v count
      this.interval = setInterval(() => this.getReservations(), 10000); //5sec.

    }

    componentWillUnmount() {
      clearInterval(this.interval);
    }
    getReservations(){   
      this.getReservationsFull("ano"); // přihlášení
      this.getReservationsFull("ne"); // Odhlášení
      
    }
    
      // Načtení pole osazenosti mše
    getReservationsFull( myValid){

    var formData = new FormData();
        formData.append('getReservationsFull', true);
      formData.append('EventId', this.props.myId);
      formData.append('myValid', myValid);

      let fetchData = { 
        method: 'POST', body: formData,      
        headers: {
           headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        },  
      }

    // A posílám
    fetch(Utils.getURL(), fetchData)   
    .then(response => response.json())
    .then(data => {          
        if ( data["success"]) {
        // Načtení data.data do tabulky
        if ( myValid === "ano") {
            if ( data["count"] > 0) {
              this.setState({myStateData: data.data }); // Po přihlášení na hlavní stránku                    
            }
            else {
              this.setState({myStateData: [] }); // Po přihlášení na hlavní stránku                    
            }        
        }        
        else{        
            if ( data["count"] > 0) {
              this.setState({myStateInvalidData: data.data }); // Po přihlášení na hlavní stránku                    
            }
            else {
              this.setState({myStateInvalidData: [] }); // Po přihlášení na hlavní stránku                    
            }          
        }
        // console.log('Stav:', "OK");  
      }
        else{
              }            
    })
    .catch((error) => {
      console.error('Chyba:', error);
    });    
}

handleRefresh = () => {
  this.getReservations();        
};

    render() {
        return (
            <div >
              <Paper className="event">
         
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                            <h3>{this.props.myName}</h3>
                            {this.props.myComment}
                            <br></br>
                            Maximální počet: {this.props.myMax} lidí.                            
                    </Grid>
                    <Grid item xs={12}>
                            <EventState 
                                myMax ={this.props.myMax}  
                                myEventId = {this.props.myId}                                                                 
                            />                            
                    </Grid>
                    <Grid item xs={12}>
                    <h3>Přihlášené osoby</h3>
                    <DetailTable 
                    myData={this.state.myStateData}
                    onRefresh={() => this.handleRefresh()} 
                    >
                    </DetailTable>
                    </Grid>

                    <Grid item xs={12}>
                    <h3>Odhlášené osoby</h3>
                    <DetailTableDelete 
                    myData={this.state.myStateInvalidData}
                    onRefresh={() => this.handleRefresh()} 
                    >
                    </DetailTableDelete>
                    </Grid>

                </Grid>
                </Paper>
            </div>
        )
    }

}